import styled from '../../../../styles/styledComponents/themeComponents';

export const TabLabelStyle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 2px 0;

  .tab-thumbnail {
    width: 28px;
    height: 18px;
    object-fit: cover;
    border-radius: 3px;
    border: 1px solid #e8e8e8;
  }

  .tab-placeholder {
    width: 28px;
    height: 18px;
    background: #f5f5f5;
    border-radius: 3px;
    border: 1px dashed #d9d9d9;
  }

  .tab-number {
    font-size: 13px;
    white-space: nowrap;
  }
`;
